/**
 * Created by pc on 2018/12/22.
 */

import { post, get } from '../../http/index'
import { BASE_URL } from '@/global/util/constants'
import qs from 'qs'
import Page from '@/global/util/Page'
const MANAGER_FINANCIAL_USER_TYPE_MENU = 'MANAGER_FINANCIAL_USER_TYPE_MENU' // 财务管理用户类型下拉菜单
const MANAGER_FINANCIAL_USER_MENU = 'MANAGER_FINANCIAL_USER_MENU' // 财务管理用户类型对应用户下拉菜单
const MANAGER_FINANCIAL_DETAILS_MENU = 'MANAGER_FINANCIAL_DETAILS_MENU' // 财务管理明细类别
const MANAGER_FINANCIAL_DETAILS_TABLE = 'MANAGER_FINANCIAL_DETAILS_TABLE' // 财务管理明细类别
const MANAGER_FINANCIAL_EDIT_USER_TYPE_MENU = 'MANAGER_FINANCIAL_EDIT_USER_TYPE_MENU' // 财务管理编辑用户类型
const MANAGER_FINANCIAL_EDIT_USER_MENU = 'MANAGER_FINANCIAL_EDIT_USER_MENU' // 财务管理编辑用户下拉菜单
const MANAGER_FINANCIAL_EDIT_TABLE = 'MANAGER_FINANCIAL_EDIT_TABLE' // 财务管理编辑表格
const MANAGER_FINANCIAL_TIME_PEROID = 'MANAGER_FINANCIAL_TIME_PEROID' // 返点时间周期下拉
const MANAGER_FINANCIAL_AUDIT_EXAM_TYPE_MENU = 'MANAGER_FINANCIAL_AUDIT_EXAM_TYPE_MENU' // 财务审核类型下拉菜单
const MANAGER_FINANCIAL_AUDIT_EXAM_TYPES_MENU = 'MANAGER_FINANCIAL_AUDIT_EXAM_TYPES_MENU' // 财务审核类型 分类下拉菜单
const MANAGER_FINANCIAL_AUDIT_STATUS_MENU = 'MANAGER_FINANCIAL_AUDIT_STATUS_MENU' // 财务审核状态
const MANAGER_FINANCIAL_AUDIT_TABLE = 'MANAGER_FINANCIAL_AUDIT_TABLE' // 财务审核表格
const MANAGER_FINANCIAL_BANK_NAME_MENU = 'MANAGER_FINANCIAL_BANK_NAME_MENU' // 银行名称下拉菜单
const MANAGER_FINANCIAL_REBATE_TABLE = 'MANAGER_FINANCIAL_REBATE_TABLE' // 返现管理表格
const MANAGER_FINANCIAL_REBATE_USER_TYPE_MENU = 'MANAGER_FINANCIAL_REBATE_USER_TYPE_MENU' // 返现管理下拉菜单
const state = {
  financial: {
    userTypeMenu: [],
    curUserType: '',
    userMenu: [],
    curUserMenu: '',
    detailsTypeMenu: [],
    curDetailsType: '',
    detailsPage: new Page(),
    detailsDown: '',
    editTypeMenu: [],
    curEditType: '',
    editUserMenu: [],
    curEditUser: '',
    editPage: new Page(),
    editDown: '',
    rebateTypeMenu: [],
    curRebateType: '',
    rebatePage: new Page(),
    rebateDown: '',
    timePeriodMenu: [],
    examTypeMenu: [],
    curExamType: '',
    examTypesMenu: [],
    curExamTypes: '',
    auditPage: new Page(),
    auditDown: '',
    auditStatusMenu: [],
    bankMenu: []
  }
}

const getters = {
  financial: state => state.financial
}

const actions = {
  async getUserTypeMenu ({ commit, state }) {
    await post('/admin/finance/usertype').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_USER_TYPE_MENU, res.data)
      }
    })
  },
  async getFinDetailsTypeMenu ({ commit, state }, { userType }) {
    await post('/admin/finance/type', { user_type: userType }).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_DETAILS_MENU, res.data)
      }
    })
  },
  getUserMenu ({ commit, state }, { userType, startTime, endTime }) {
    post('/admin/finance/user', {
      user_type: userType,
      start_time: startTime,
      end_time: endTime
    }).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_USER_MENU, res.data)
      }
    })
  },
  async getEditTypeMenu ({ commit, state }) {
    await post('/admin/finance/edittype').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_EDIT_USER_TYPE_MENU, res.data)
      }
    })
  },
  async getRebateTypeMenu ({ commit, state }, { type = 'rebate_select' } = {}) {
    await get('/interface/etcd/item/' + type).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_REBATE_USER_TYPE_MENU, res.data)
      }
    })
  },
  async getEditUserMenu ({ commit, state }, { userType }) {
    await get('/admin/finance/edit', { type: userType }).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_EDIT_USER_MENU, res.data)
      }
    })
  },
  async getTimePeriod ({ commit, state }) {
    await get('/admin/finance/rebate-option').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_TIME_PEROID, res.data)
      }
    })
  },
  async getExamTypeMenu ({ commit, state }) {
    await get('/admin/finance/examinetype').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_AUDIT_EXAM_TYPE_MENU, res.data)
      }
    })
  },
  async getExamTypesMenu ({ commit, state }, { type } = {}) {
    await get('/admin/finance/examinetypes', { type: type }).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_AUDIT_EXAM_TYPES_MENU, res.data)
      }
    })
  },
  getAuditStatusMenu ({ commit, state }) {
    get('/interface/etcd/item/finance_examine_status').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_AUDIT_STATUS_MENU, res.data)
      }
    })
  },
  getBankMenu ({ commit, state }) {
    get('/interface/etcd/item/bank_name').then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_BANK_NAME_MENU, res.data)
      }
    })
  },
  getPriceTypeMenu ({ commit, state }, { type = 'increase_type' } = {}) {
    return get('/interface/etcd/item/' + type)
  },
  getFinDetailsTable (
    { commit, state },
    {
      userType,
      startTime,
      endTime,
      userId,
      adverName,
      accountName,
      type,
      pageSize = state.financial.detailsPage.pageSize,
      currentPage = state.financial.detailsPage.currentPage
    }
  ) {
    let params = {}
    params.user_type = userType
    params.start_time = startTime
    params.end_time = endTime
    params.user_id = userId
    params.type = type
    params.page = currentPage
    params.user_name = adverName
    params.account_name = accountName
    params.page_size = pageSize
    get('/admin/finance/detailed', params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + '/admin/finance/detailed?' + qs.stringify(params)
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_DETAILS_TABLE, { data: res.data, url: downUrl })
      }
    })
  },
  getAuditFinTable (
    { commit, state },
    {
      startTime,
      endTime,
      userName,
      type,
      accountName,
      pageSize = state.financial.auditPage.pageSize,
      currentPage = state.financial.auditPage.currentPage
    }
  ) {
    let params = {}
    params.type = type
    params.start_time = startTime
    params.end_time = endTime
    params.user_name = userName
    params.page = currentPage
    params.page_size = pageSize
    params.account_name = accountName
    get('/admin/finance/examine', params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + '/admin/finance/examine?' + qs.stringify(params)
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_AUDIT_TABLE, { data: res.data, url: downUrl })
      }
    })
  },
  getEditFinTable (
    { commit, state },
    {
      userType,
      userId,
      userName,
      accountName,
      pageSize = state.financial.editPage.pageSize,
      currentPage = state.financial.editPage.currentPage
    }
  ) {
    let params = {}
    params.type = userType
    params.user_id = userId
    params.page = currentPage
    params.page_size = pageSize
    params.user_name = userName
    params.account_name = accountName
    get('/admin/finance/edit', params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + '/admin/finance/edit?' + qs.stringify(params)
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_EDIT_TABLE, { data: res.data, url: downUrl })
      }
    })
  },
  getRebateData (
    { commit, state },
    {
      userType,
      userId,
      userName,
      accountName,
      pageSize = state.financial.editPage.pageSize,
      currentPage = state.financial.editPage.currentPage,
      activeName,
      startTime,
      endTime
    }
  ) {
    let params = {}
    params.user_type = userType
    params.page = currentPage
    params.account_name = accountName
    params.page_size = pageSize
    let api = activeName === '1' ? '/admin/finance/advertiser-list' : '/admin/finance/rebate-list'
    if (activeName === '2') {
      params.user_id = userId
      params.user_name = userName
      params.start_time = startTime
      params.end_time = endTime
    } else {
      params.id = userId
      params.name = userName
    }
    get(api, params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + api + '?' + qs.stringify(params)
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_REBATE_TABLE, { data: res.data, url: downUrl })
      }
    })
  }
}

const mutations = {
  [MANAGER_FINANCIAL_USER_TYPE_MENU] (state, result) {
    state.financial.userTypeMenu = result
    state.financial.curUserType = result[0].value
  },
  [MANAGER_FINANCIAL_DETAILS_MENU] (state, result) {
    state.financial.detailsTypeMenu = result
    state.financial.curDetailsType = result[0].value
  },
  [MANAGER_FINANCIAL_USER_MENU] (state, result) {
    state.financial.userMenu = result
    state.financial.curUserMenu = result[0].value
  },
  [MANAGER_FINANCIAL_EDIT_USER_TYPE_MENU] (state, result) {
    state.financial.editTypeMenu = result
    state.financial.curEditType = result[0].value
  },
  [MANAGER_FINANCIAL_REBATE_USER_TYPE_MENU] (state, result) {
    state.financial.rebateTypeMenu = result
    state.financial.curRebateType = result[0].value
  },
  [MANAGER_FINANCIAL_EDIT_USER_MENU] (state, result) {
    state.financial.editUserMenu = result
    state.financial.curEditUser = result[0].value
  },
  [MANAGER_FINANCIAL_TIME_PEROID] (state, result) {
    state.financial.timePeriodMenu = result
  },
  [MANAGER_FINANCIAL_AUDIT_EXAM_TYPE_MENU] (state, result) {
    state.financial.examTypeMenu = result
    state.financial.curExamType = result[0].value
  },
  [MANAGER_FINANCIAL_AUDIT_STATUS_MENU] (state, result) {
    state.financial.auditStatusMenu = result
  },
  [MANAGER_FINANCIAL_AUDIT_EXAM_TYPES_MENU] (state, result) {
    state.financial.examTypesMenu = result
    state.financial.curExamTypes = result[0].value
  },
  [MANAGER_FINANCIAL_BANK_NAME_MENU] (state, result) {
    state.financial.bankMenu = result
  },
  [MANAGER_FINANCIAL_DETAILS_TABLE] (state, result) {
    state.financial.detailsPage.setPageData(
      {
        header: result.data.header,
        data: result.data.data,
        total: result.data.count
      },
      false
    )
    state.financial.detailsDown = result.url
  },
  [MANAGER_FINANCIAL_AUDIT_TABLE] (state, result) {
    state.financial.auditPage.setPageData(
      {
        header: result.data.header,
        data: result.data.data,
        total: result.data.total
      },
      false
    )
    state.financial.auditDown = result.url
  },
  [MANAGER_FINANCIAL_EDIT_TABLE] (state, result) {
    state.financial.editPage.setPageData(
      {
        header: result.data.header,
        data: result.data.data,
        total: result.data.total
      },
      false
    )
    state.financial.editDown = result.url
  },
  [MANAGER_FINANCIAL_REBATE_TABLE] (state, result) {
    state.financial.rebatePage.setPageData(
      {
        header: result.data.header,
        data: result.data.data,
        total: result.data.count
      },
      false
    )
    state.financial.rebateDown = result.url
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
